import state from './tag.state'
import actions from './tag.actions'
import mutations from './tag.mutations'

export default {
  state,
  actions,
  mutations
}
